import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import Sidebar, { SIDEBAR_WIDTH_EXPANDED, SIDEBAR_WIDTH_COLLAPSED } from './Sidebar';
import Header from './Header';
import GlobalOasisPillFrame from './GlobalOasisPillFrame';
import WorkflowModal from './WorkflowModal';

const AppShell = ({ children }) => {
  const [sidebarExpanded, setSidebarExpanded] = useState(() => {
    const stored = localStorage.getItem('di_sidebar_expanded');
    return stored === null ? true : stored === 'true';
  });

  useEffect(() => {
    localStorage.setItem('di_sidebar_expanded', sidebarExpanded.toString());
  }, [sidebarExpanded]);

  const toggleSidebar = () => {
    setSidebarExpanded(prev => !prev);
  };

  const sidebarWidth = sidebarExpanded ? SIDEBAR_WIDTH_EXPANDED : SIDEBAR_WIDTH_COLLAPSED;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh', overflow: 'hidden' }}>
      <Header sidebarWidth={sidebarWidth} />
      <Box sx={{ display: 'flex', flex: 1, overflow: 'hidden' }}>
        <Sidebar expanded={sidebarExpanded} onToggle={toggleSidebar} />
        <Box
          component="main"
          sx={{
            flex: 1,
            marginLeft: `${sidebarWidth}px`,
            overflow: 'auto',
            position: 'relative',
            transition: 'margin-left 0.2s ease',
            minWidth: 0,
          }}
        >
          {children}
        </Box>
      </Box>
      <GlobalOasisPillFrame />
      <WorkflowModal />
    </Box>
  );
};

export default AppShell;
